import React from 'react'
import '../Styles/Brand.css'
import '../assets/css/swiper-bundle.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";




import { useState } from 'react'


export const BrandArea2 = () => {

  var setting2 = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
          speed: 300,
        }
      },
            {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
<div>
  <div className="bd-brand-area gray-bg">
    <div className="container" style={{ maxWidth: "2000px", height: "130px", backgroundColor: "#01536E" }}>
      <div className="bd-brand-active swiper-container" style={{ height: "100%", display: "flex", alignItems: "center" }}>

        <div className="slider d-flex justify-content-center align-items-center" style={{ width: "100%", height: "100%" }}>
          <Slider {...setting2}>
            <div>
              <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
                <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>BPM</a>
              </div>
            </div>
            <div>
              <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
                <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>Avaloq</a>
              </div>
            </div>
            <div>
            <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>Temenos</a>
            </div>
            </div>
            <div>
            <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>Supply Chain Planning</a>
            </div>
            </div>
            <div>
            <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>D365</a>
            </div>
            </div>
            <div>
            <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>Ms Power Apps</a>
            </div>
            </div>
            <div>
            <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>Journey Redesign</a>
            </div>
            </div>
            <div>
              <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>UI/UX</a>
            </div>
            </div>
            <div>
              <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>AI/ML Strategy</a>
            </div>
            </div>
                    <div>
              <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>MS D365</a>
            </div>
            </div>
            {/* <div className="bd-brand-single1 swiper-slide" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "130px" }}>
            <div>
              <a style={{ color: "white", fontSize: "25px", textAlign: "center", width: "160px" }}>MS D365</a>
            </div>
            </div> */}
          </Slider>
        </div>

      </div>
    </div>
  </div>
</div>

  )
}
